import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import { mapUmmsCombinedSortByToSortBy } from 'src/apis/iip-service/mappings';
import type { UmmsOverviewParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useUmms } from 'src/apis/iip-service/use-umms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useUmmsPageParams } from 'src/pages/market-messages/urgent-market-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const UrgentMarketMessagesOverview: FC<Props> = ({ iipService }) => {
  const params = useUmmsPageParams();

  const transformedParams = useMemo(() => {
    const { start, pageSize, marketParticipantIds, sortBy, ...rest } =
      params.value;
    return {
      offset: start,
      limit: pageSize,
      marketParticipantIds: marketParticipantIds.map(
        (marketParticipant) => marketParticipant.value
      ),
      ...mapUmmsCombinedSortByToSortBy(sortBy),
      ...rest,
    } satisfies UmmsOverviewParams;
  }, [params.value]);

  const umms = useUmms({ iipService, params: transformedParams });

  if (!umms.response) return <PageSpinner />;
  return <Page iipService={iipService} umms={umms} pageParams={params} />;
};
